<template>
    <section id="section-appointment">
        <div class="section-head">
            <h2>Buat Janji</h2>
        </div>
        <div class="section-body">
            <div class="section-body-inner">
                <div class="sbi-row">
                    <div class="sbi-column">
                        <div class="sbi-param">
                            <span>Nama Dokter</span>
                        </div>
                        <div class="sbi-value">
                            <input type="hidden" name="doctor_id" label="ID" class="input-id" id="input-doctor-id"/>
                            <input type="hidden" name="doctor" label="Dokter" class="input" id="input-doctor" required/>
                            <div class="sbi-select">
                                <div class="sbi-select-button" id="ssb-select-doctor" @click="optionToggle('ssb-select-doctor');">
                                    <div class="btn-cover"></div>
                                    <div class="ssb-text" id="ssb-text-doctor">
                                        <span>Pilih Dokter</span>
                                    </div>
                                    <div class="ssb-icon float-icon">
                                        <img src="../../assets/images/icons/arrow-1.png" alt="morula melinda hospital"/>
                                    </div>
                                </div>
                                <div class="sbi-select-option float">
                                    <div class="sso-button" v-for="doctor in doctors" :key="doctor" @click="selectDoctor(doctor.id); resetTime(); optionToggle('ssb-select-doctor'); clearWarning('warning-doctor');">
                                        <span>{{ doctor.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="warning" id="warning-doctor"></div>
                    </div>
                </div>
                <div class="sbi-row">
                    <div class="sbi-column">
                        <div class="sbi-param">
                            <span>Nama Pasien</span>
                        </div>
                        <div class="sbi-value">
                            <div class="sbi-input">
                                <input type="text" name="patients_name" label="Nama Pasien" class="input" id="input-patient" autocomplete="off" @input="clearWarning('warning-patients_name');" required/>
                            </div>
                        </div>
                        <div class="warning" id="warning-patients_name"></div>
                    </div>
                    <div class="sbi-column">
                        <div class="sbi-param">
                            <span>Tanggal Lahir</span>
                        </div>
                        <div class="sbi-value">
                            <div class="sbi-input">
                                <input type="date" name="patients_birth" label="Tanggal Lahir" class="input" id="input-birth" @change="clearWarning('warning-patients_birth');"/>
                            </div>
                        </div>
                        <div class="warning" id="warning-patients_birth"></div>
                    </div>
                    <div class="sbi-column">
                        <div class="sbi-param">
                            <span>No. Hp</span>
                        </div>
                        <div class="sbi-value">
                            <div class="sbi-input">
                                <input type="number" name="cellular" label="Nomor Ponsel" class="input" id="input-cellular" autocomplete="off" @input="clearWarning('warning-cellular');" required/>
                            </div>
                        </div>
                        <div class="warning" id="warning-cellular"></div>
                    </div>
                </div>
                <div class="sbi-row">
                    <div class="sbi-column">
                        <div class="sbi-param">
                            <span>Email</span>
                        </div>
                        <div class="sbi-value">
                            <div class="sbi-input">
                                <input type="text" name="email" label="Email" class="input" id="input-email" autocomplete="off" @input="clearWarning('warning-email');"/>
                            </div>
                        </div>
                        <div class="warning" id="warning-email"></div>
                    </div>
                </div>
                <div class="sbi-row">
                    <div class="sbi-column">
                        <div class="sbi-param">
                            <span>Tanggal Perjanjian</span>
                        </div>
                        <div class="sbi-value">
                            <div class="sbi-input">
                                <input type="date" name="appointment_date" label="Tanggal Perjanjian" class="input" id="input-appointment-date" @change="selectDate" @click="clearWarning('warning-appointment_date');" required/>
                            </div>
                        </div>
                        <div class="warning" id="warning-appointment_date"></div>
                    </div>
                    <div class="sbi-column">
                        <div class="sbi-param">
                            <span>Pilih Jam</span>
                        </div>
                        <div class="sbi-value">
                            <div class="sbi-select">
                                <input type="hidden" name="appointment_hour" label="Jam" class="input" id="input-appointment-hour" required/>
                                <div class="sbi-select-button" id="ssb-select-time" @click="optionToggle('ssb-select-time');">
                                    <div class="btn-cover"></div>
                                    <div class="ssb-text" id="ssb-text-time">
                                        <span>Pilih Jam</span>
                                    </div>
                                    <div class="ssb-icon float-icon">
                                        <img src="../../assets/images/icons/arrow-1.png" alt="morula melinda hospital"/>
                                    </div>
                                </div>
                                <div class="sbi-select-option float" v-if="schedules">
                                    <template v-if="schedules.length > 0">
                                        <div class="sso-button" v-for="sc in schedules" :key="sc" @click="optionToggle('ssb-select-time'); selectTime(sc); clearWarning('warning-appointment_hour');">
                                            <span>{{ sc }}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <p class="sso-note">Tidak ada jadwal pada hari yang anda pilih</p>
                                    </template>
                                </div>
                                <div class="sbi-select-option float" v-else>
                                    <p class="sso-note">Pilih Dokter dan Tanggal Perjanjian dahulu</p>
                                </div>
                            </div>
                        </div>
                        <div class="warning" id="warning-appointment_hour"></div>
                    </div>
                </div>
                <div class="sbi-row">
                    <div class="sbi-column sbi-column-message">
                        <div class="sbi-param">
                            <span>Pesan</span>
                        </div>
                        <div class="sbi-value">
                            <div class="sbi-textarea">
                                <textarea name="message" label="Pesan" class="input" id="input-message" @input="clearWarning('warning-message');"></textarea>
                            </div>
                        </div>
                        <div class="warning" id="warning-message"></div>
                    </div>
                </div>
                <div class="sbi-row">
                    <div class="sbi-button">
                        <button v-if="submitProcess">Memproses data.....</button>
                        <button @click="submitAppointment" v-else>Buat Janji</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    import { computed } from '@vue/reactivity';
    import { useDoctorStore } from '@/stores/doctor';
    import { optionToggle, clearWarning } from '@/functions/general';
    import { selectDoctor, selectDate, selectTime, submitAppointment, resetTime } from '@/functions/appointment';
    const doctors = computed(() => useDoctorStore().doctors);
    const schedules = computed(() => useDoctorStore().schedules);
    const submitProcess = computed(() => useDoctorStore().submitProcess);
</script>

<style scoped>
    section{
        padding: 5rem 10% 2.5rem 10%;
        transition: 0.2s;
    }
    .section-head{
        text-align: center;
    }
    .section-head h2{
        font-size: 3rem;
        font-weight: 700;
        color: var(--primary);
        margin: 1rem 0 2.5rem 0;
    }
    .sbi-row{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 1rem 0 1rem 0;
    }
    .sbi-column{
        width: 33.33%;
        padding: 0 2rem 0 0;
        transition: 0.2s;
    }
    .sbi-column-message{
        width: 50%;
        transition: 0.2s;
    }
    .sbi-param{
        color: var(--primary);
        padding: 1rem 0 1rem 0;
        font-weight: 500;
        font-size: 1.2rem;
    }
    .sbi-select{
        position: relative;
        color: var(--grey);
        font-size: 0.9rem;
        user-select: none;
    }
    .sbi-select-button{
        position: relative;
        width: 100%;
        height: 50px;
        display: flex;
        background: var(--smoke);
        padding: 1rem;
        border-radius: 5rem;
        cursor: pointer;
        user-select: none;
        overflow: hidden;
    }
    .btn-cover{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        /* background: #0000009d; */
    }
    .ssb-text{
        width: 90%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .ssb-icon{
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: right;
    }
    .ssb-icon img{
        transition: 0.2s;
    }
    .ssb-icon-active img{
        transform: rotate(180deg);
    }
    .sbi-select-option{
        position: absolute;
        top: 110%;
        left: 0;
        width: 100%;
        max-height: 400px;
        display: none;
        background: var(--white);
        border: 2px solid var(--smoke);
        border-radius: 1.5rem;
        overflow-y: auto;
        z-index: 20;
        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    }
    .sbi-select-option::-webkit-scrollbar {
        width: 6px;
    }
    .sbi-select-option::-webkit-scrollbar-thumb {
        background: var(--softgrey);
        border-radius: 10px;
    }
    .sso-active{
        display: block;
    }
    .sso-button{
        min-height: 50px;
        height: auto;
        display: flex;
        align-items: center;
        padding: 0.8rem 1.5rem;
        transition: 0.2s;
        cursor: pointer;
        user-select: none;
        border-bottom: 1px solid var(--smoke);
        line-height: 1.3;
    }
    .sso-button:last-child {
        border-bottom: none;
    }
    .sso-button:hover{
        background: var(--smoke);
    }
    .sso-note{
        margin: 1rem 0 1rem 0;
        text-align: center;
        font-size: 1rem;
        font-family: roboto;
        font-weight: 300;
        font-style: italic;
        color: var(--softgrey);
    }
    .sbi-input{
        width: 100%;
        height: 50px;
        padding: 0.5rem 1rem 0.5rem 1rem;
        border: 2px solid var(--smoke);
        border-radius: 5rem;
    }
    .sbi-input input{
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: none;
        color: var(--grey);
    }
    .sbi-textarea{
        width: 100%;
        height: 200px;
        border: 2px solid var(--smoke);
        border-radius: 1.5rem;
        overflow: hidden;
    }
    .sbi-textarea textarea{
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: none;
        color: var(--grey);
        font-family: sans-serif;
        font-size: 1rem;
        padding: 1rem;
    }
    .sbi-button button{
        background: var(--primary);
        color: var(--white);
        border: none;
        border-radius: 5rem;
        padding: 1rem 2rem 1rem 2rem;
        font-size: 1.5rem;
        font-weight: 600;
        cursor: pointer;
        user-select: none;
    }
    @media only screen and (max-width: 1500px){
        section{
            padding: 5rem 5% 2.5rem 5%;
        }
    }
    @media only screen and (max-width: 1200px){
        .sbi-column{
            width: 50%;
        }
        .sbi-column-message{
            width: 100%;
        }
    }
    @media only screen and (max-width: 750px){
        section{
            padding: 5rem 2.5% 2.5rem 2.5%;
        }
        .sbi-column{
            width: 100%;
            padding: 0;
        }
    }
</style>